import { match as u } from "ts-pattern";
import { c as a } from "./strings-CHELOtPc.js";
import { colors as n } from "@silversea-ssc/design-system-tokens";
const t = "Backgrounds-module_background-white__i8Rqm",
  d = "Backgrounds-module_background-titanium__68gGY",
  e = "Backgrounds-module_background-titanium-dark__QnmO1",
  k = "Backgrounds-module_background-neutral01__EAoAX",
  g = "Backgrounds-module_background-neutral05__KXFUW",
  l = "Backgrounds-module_background-neutral10__LjJz7",
  s = "Backgrounds-module_background-neutral35__AcZNI",
  p = "Backgrounds-module_background-neutral60__V57eE",
  b = "Backgrounds-module_background-transparent__GzCHR",
  _ = "Backgrounds-module_background-product-type-color01__Bc5Az",
  i = "Backgrounds-module_background-product-type-color02__pd6ER",
  m = "Backgrounds-module_background-product-type-color03__H3Z2L",
  y = "Backgrounds-module_background-product-type-color04__diLcT",
  c = {
    backgroundWhite: t,
    backgroundTitanium: d,
    backgroundTitaniumDark: e,
    backgroundNeutral01: k,
    backgroundNeutral05: g,
    backgroundNeutral10: l,
    backgroundNeutral35: s,
    backgroundNeutral60: p,
    backgroundTransparent: b,
    backgroundProductTypeColor01: _,
    backgroundProductTypeColor02: i,
    backgroundProductTypeColor03: m,
    backgroundProductTypeColor04: y
  },
  N = o => {
    if (!o) return c.backgroundTransparent;
    const r = "background".concat(a(o));
    return c[r];
  },
  h = o => u(o).with("productTypeColor01", () => "var(--product-type-color-01)").with("productTypeColor02", () => "var(--product-type-color-02)").with("productTypeColor03", () => "var(--product-type-color-03)").with("productTypeColor04", () => "var(--product-type-color-04)").with("transparent", () => "transparent").otherwise(r => n[r]);
export { h as a, N as c };